// extracted by mini-css-extract-plugin
export default {"cart-icon":"Hero_cart-icon__GTAe8","fill-path":"Hero_fill-path__iP4dR","cart-button":"Hero_cart-button__Hkqba"};